<!--
     <FilterCentro
       :filters="ExplorerFilters"
       @update="handle_update(ExplorerFilters)"
     />
-->

<template>
  <div v-if="show_the_filter">
    <v-menu
      ref="activator"
      v-model="menu_open"
      offset-y
      min-width="290px"
      dense
      :close-on-content-click="false"
      @input="pull_filters"
    >
      <template v-slot:activator="{ on }">
        <slot name="activator">
          <v-btn
            v-if="!is_mobile"
            @click.stop="pull_filters"
            v-on="on"
            class="qmkey-btn-process-filter"
            :class="filtered_count ? 'qmkey-btn-process-filter-active' : ''"
          >
            Centros <span v-if="filtered_count">({{ selection_count }})</span>
          </v-btn>

          <v-btn
            v-else
            @click.stop="pull_filters"
            icon
            small
            v-on="on"
          >
            <v-icon small>mdi-domain</v-icon>
          </v-btn>
        </slot>
      </template>

      <div class="fc-card">
        <div class="fc-body">
          <div v-if="selection.length > 0" style="max-width : 100%" persistent-hint>
            <div v-if="selection.length < 10" class="fc-chip-cont">
              <div
                class="fc-chip-inner"
                v-for="cid in selection"
                :key="cid"
              >
                <div class="fc-chip-img-cont">
                  <img class="fc-centro-img" :src="centro_logo(centros.find(item => item.id == cid))" @error="failed_logo(centros[cid])" />
                </div>
              </div>
            </div>
            <div
              v-else
              class="qmkey-generic-process-filter-selection-text"
            >
              {{ `${selection_count} centros seleccionados` }}
            </div>
          </div>

          <div>
            <v-text-field
              v-model="search_text"
              clearable
              color="primary"
              label="Buscar"
              class="pl-4 pr-4"
            ></v-text-field>
          </div>

          <div class="fc-list">
            <div class="fc-centro" v-for="centro in centro_list" @click="toggle_centro(centro)">
              <v-checkbox :input-value="is_selected(centro)" color="primary"/>
              <div class="fc-centro-img-cont">
                <img class="fc-centro-img" :src="centro_logo(centro)" @error="failed_logo(centro)" />
              </div>
              <div class="fc-centro-indent" :style="indent_style(centro)"></div>
              <div class="fc-centro-name">{{ centro.name }}</div>
            </div>
          </div>
        </div>

        <div class="fc-actions">
          <v-btn
            class="qmkey-modal-dialog-button-secundary"
            text 
            color="primary"
            small
            @click="reset"
          >
            Limpiar
          </v-btn>
          <v-btn 
            class="qmkey-modal-dialog-button-submit"
            text 
            small
            @click="confirm_selection"
          >
            Enviar
          </v-btn>
        </div>
      </div>
    </v-menu>
  </div>
</template>

<style lang="scss">
  @import '@/sass/explorer.scss';

  .fc-card {
    background-color: white;
    padding: 8px;
  }

  .fc-actions {
    margin-top: 16px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
  }

  .fc-chip-cont {
    display: flex;
    flex-direction: row;
    gap: 8px;
  }

  .fc-chip-inner {
    display: flex;
    flex-direction: row;
    gap: 8px;
    height: 100%;
    align-items: center;
    justify-content: flex-start;
    max-height: 24px;
  }

  .fc-chip-img-cont {
    height: 100%;
    max-height: 32px;
    width: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .fc-chip-name {
    padding-left: 4px;
  }

  .fc-indent {
    width: 0px;
    height: 100%;
  }

  .fc-list {
    width: 100%;
    display: flex;
    flex-direction: column;
    overflow-x: hidden;
    overflow-y: scroll;
    max-height: 50vh;
    max-width: 70vw;
    cursor: default;
    font-family: Roboto,sans-serif;
  }

  .fc-centro {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 42px;
    padding: 4px 0px 4px 8px;
  }
  .fc-centro:hover {
    background-color: #e4e4e4;
  }

  .fc-centro-img-cont {
    height: 100%;
    width: 64px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .fc-centro-img {
    height: 100%;
    width: 100%;
    object-fit: contain;
  }

  .fc-centro-name {
    padding-left: 8px;
    width: 95%;
  }
</style>

<script>
  import { mapState, mapGetters } from 'vuex'
  import { resolve_logo } from '@/utils/logos';
  import ProcessMenuItem from '@/components/explorer/ProcessMenuItem'
  import ResponsiveMenuDialog from '@/components/ResponsiveMenuDialog'
  import QTree from '@/utils/QTree'
  import { QFilters, get_qfilter } from '@/qunit/filters';

  const FALLBACK_LOGO = require('@/assets/image_not_found.png');
  
  export default {
    name: 'FilterCentro',

    components: {
      ResponsiveMenuDialog,
      ProcessMenuItem,
    },

    props: {
      disabled: {
        type: Boolean,
        default: false,
      },
      filters: {required: true},
      is_mobile: {type: Boolean, default: false},
    },

    data: () => ({
      menu_open: false,
      search_text: '',
      selection: [],
      logofails: [], // [centro_id]
    }),

    computed: {
      ...mapState(['site_centros', 'bpmap']),
      ...mapGetters(['centro_id', 'site_id']),

      centros() {
        return this.site_centros[this.site_id];
      },

      show_the_filter() {
        return (
          (!this.filters.get_filter_value('business_process') || (this.bpmap.get_value(this.filters.get_filter_value('business_process'))||{}).is_shared)
          && (this.centro_list.length > 1)
        );        
      },

      selection_count() {
        return this.selection.length;
      },

      filtered_count() {
        return (this.selection.length > 1
              || (this.selection.length == 1
              && this.selection[0] != this.centro_id));
      },

      selection_set() {
        return new Set(this.selection);
      },

      centro_list() {
        const search = (this.search_text || '').toLowerCase();
        let res = Object.values(this.centros);
        if (search) {
          res = res.filter(c => c.name.toLowerCase().indexOf(search) >= 0);
        }
        res.sort((a, b) => a.path_str.localeCompare(b.path_str));
        return res;
      },

      processes_tree() {
        return new QTree(this.allProcesses);
      },

      items_tree() {
        return Object.values(this.processes_tree.get_array_tree());
      },

      logofails_set() {
        return new Set(this.logofails);
      },
    },

    methods: {
      indent_style(centro) {
        return `padding-left: ${(centro.path.length-1)*20}px`;
      },

      is_selected(centro) {
        return this.selection_set.has(centro.id);
      },

      centro_logo(centro) {
        let failed = !!centro;
        if (centro) {
          failed = this.logofails_set.has(centro.id);
          return resolve_logo(centro.logo, failed);
        }
      },

      toggle_centro(centro) {
        const pos = this.selection.indexOf(centro.id);
        if (pos < 0) {
          this.selection.push(centro.id);
        } else {
          this.selection.splice(pos, 1);
        }
      },

      confirm_selection() {
        if (this.selection.length <= 0) {
          this.selection.push(this.centro_id);
        }
        const new_ids = this.selection.sort();
        if ((this.filters.get_filter_value('centro_list') || []).join(',') != new_ids.join(',')) {
          let filters = new QFilters();
          filters.set_filter(get_qfilter('centro_list',[...new_ids]));
          this.$emit('update', filters);
        }
        this.menu_open = false;
      },

      reset() {
        this.selection = [this.centro_id];
      },

      pull_filters() {
        // If selected and filter ids are different, overwrite selected ids
        if ((this.filters.get_filter_value('centro_list') || []).join(',') != this.selection.join(',')) {
          this.selection = (this.filters.get_filter_value('centro_list') || []);
        }
      },

      get_value() {
        let res = new QFilters();
        res.set_filter(get_qfilter('centro_list',[...this.selection]));
        return res;
      },

      failed_logo(centro) {
        if (centro) {
          console.error('Error: loading centro logo \''+centro.name+' ('+centro.id+')\'');
          this.logofails.push(centro.id);
        } else {
          console.error('Error: couldn\'t load logo, there is no centro');
        }
      },
    },

    mounted() {
      this.pull_filters();
      if (this.selection.length <= 0) {
        this.reset();
      }
    },

    watch: {
      filters(value) {
        this.pull_filters();
      },
    },
  }
</script>
